<app-bread-crumb [items]="[{text:  'notícias',link:'/admin/news'},{text:pageTitle}]"
  [sectionTitle]="pageTitle"></app-bread-crumb>

  <section class="content">

    <form [formGroup]="objectForm" novalidate (ngSubmit)="submitForm()">

    <ng-box [boxIcon]="'fa fa-newspaper-o'" [boxTitle]="'Dados da Notícia'" [showBoxFooter]="true">

    <!-- cabesalho do box -->
    <ng-container class="ng-box-header">
        <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}">
        </ng-button>
    </ng-container>

      <ng-container class="ng-box-content">

          <div class="row">

            <div class="col-md-6">

              <app-input label="Clube(*)" errorMessage="Campo obrigatório">
               <select formControlName="clubs_id" class="form-control">
                 <option *ngFor="let club of clubs"  [value]="club.id">{{club.name}}</option>
               </select>
              </app-input>

            </div>
            <div class="col-md-6">

              <app-input label="Titulo(*)" errorMessage="Campo obrigatório">
                <input type="text" formControlName="title" class="form-control">
              </app-input>

            </div>
            
          </div>

          <div class="row">

            <div class="col-md-6">

              <app-input label="Imagem {{this.currentAction!=='edit'?'(*)':''}}" errorMessage="Campo obrigatório">
                <div class="upload-btn-wrapper">
                  <button class="btn btn-outline-danger btn-block">
                    <i class="fa fa-cloud-upload"> Clique aqui para selecionar imagem</i>
                  </button>
                  <small class="text-primary">{{ iptFile?.files[0]?.name }}</small>
                  <input #iptFile type="file" formControlName="pic">
                </div>
              </app-input>

              

            </div>

            
            <div class="col-md-6">

              <div class="form-group">

                <app-input label="Estado" errorMessage="Campo obrigatório">

                  <select formControlName="estados_id" class="form-control">
                    <option value="1">Activo</option>
                    <option value="2">Suspenso</option>
                  </select>

                </app-input>
                
              </div>

            </div>
          </div>

          <div class="row">

            <div class="col-md-12">
              <app-input label="Descrição(*)" errorMessage="Campo obrigatório">
                <angular-editor [config]="editorConfig" [placeholder]="'Enter text here...'" formControlName="description"></angular-editor>
              </app-input>
            </div>

          </div>

       
       
      </ng-container>

      <ng-container class="ng-box-footer">
        <div class="row">
          <div class="col-xs-12">
            <ng-button class="pull-right" [button]="{
              name:'salvar',
              color:'danger',
              faIconClass:'fa fa-save',
              type:'submit',
              loadingText:'SALVANDO',
              isLoading:isButtonLoading,
              isDisabled:isButtonLoading || objectForm.invalid}">
          </ng-button>
          </div>
        </div>
      </ng-container>

    </ng-box>

  </form>

  </section>